module.exports = __webpack_public_path__ + "fonts/IstokWeb-BoldItalic.43e14d82.ttf";